module.exports = __webpack_public_path__ + "static/img/he8.6762479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he8.png
// module id = WQrM
// module chunks = 1